import React from 'react'
import _ from 'lodash'
import styled from 'styled-components'
import { darken } from 'polished'

const Button = styled.button`
  color: ${props => props.theme.colors.white};
  background-color: ${props => props.theme.colors.green};
  border-radius: ${props => props.theme.borderRadius.round};
  width: 40px;
  height: 40px;
  cursor: pointer;
  margin: 20px 10px;
  outline: 0;
  font-size: 20px;
  font-weight: 600;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    background-color: ${props => darken(0.05, props.theme.colors.green)};
  }

  @media (max-width: 768px) {
    margin: 20px 0;
  }
`

const defaultCustom = {
  label: '',
  enabled: true,
  value: '',
  custom: true,
}

export default ({ push, withCustom }) => (
  <Button onClick={() => push(_.isPlainObject(withCustom) ? withCustom : defaultCustom)}>
    +
  </Button>
)
